<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => { this.searchForm = form }">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="兑换门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择">
                <a-select-option v-for="item in branches" :key="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商" fieldDecoratorId="supplier_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in suppliers" :key="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="入库类型" fieldDecoratorId="inner_type">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="1">采购</a-select-option>
                <a-select-option :key="2">调拨</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType='submit'>查询</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" @click="handleList" :loading="loading">生成订单</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" :loading="createAllPurchaseOrderLoading"
                @click="createAllPurchaseOrder">一键生成订单</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" icon="export" :loading="downloadLoading" @click="handleExport">导出订单</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="type" slot-scope="text, record">
        <p>{{ text }}</p>
        <p>{{ record.specification }}</p>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <a @click="handleDelete(record)">删除</a>
        </div>
      </template>
    </s-table>

    <a-modal title="确认订单" v-model="visible" okText='提交' @ok="handleOk" @cancel="handleCancel">
      <P>{{ total }}</P>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getCartList, sureCart, deleteCart, getTotal, createAllPurchaseOrder } from '@/api/purchase'
import { getBranchList } from '@/api/branch'
import { getSupplierList } from '@/api/supplier'
import { encodeJsonToQuery } from '@/utils/util'
import { ACCESS_TOKEN } from "@/store/mutation-types"

export default {
  name: "Cart",
  components: {
    STable
  },
  data() {
    return {
      visible: false,
      queryParam: {},
      branches: [],
      suppliers: [],
      choose: {},
      total: '',
      loading: false,
      downloadLoading: false,
      createAllPurchaseOrderLoading: false,
      columns: [
        {
          title: '商品名称',
          dataIndex: 'name'
        },
        {
          title: '门店名称',
          dataIndex: 'branch_name'
        },
        {
          title: 'sku',
          dataIndex: 'sku',
        },
        {
          title: '下单数量',
          dataIndex: 'quantity',
        },
        {
          title: '供应商',
          dataIndex: 'supplier_name',
        },
        {
          title: '订购单价',
          dataIndex: 'unit_price'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      loadData: params => {
        return getCartList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  created() {
    this.getBranchList()
    this.getSupplierList()
  },
  methods: {
    createAllPurchaseOrder() {
      this.createAllPurchaseOrderLoading = true
      createAllPurchaseOrder().then(res => {
        this.$message.success('上架成功')
        this.$refs.table.refresh()
      })
        .finally(() => {
          this.createAllPurchaseOrderLoading = false
        })
    },
    getBranchList: function () {
      getBranchList().then(res => {
        this.branches = res.list
      })
    },
    getSupplierList: function () {
      getSupplierList().then(res => {
        this.suppliers = res.list
      })
    },
    handleDelete(row) {
      const _this = this
      this.$confirm({
        title: '警告',
        content: '真的要删除吗?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteCart(row.id).then(res => {
            _this.$refs.table.refresh()
            _this.$message.success('删除成功')
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });

    },
    handleSearch(e) {
      e.preventDefault()
      this.queryParam = {
        branch_id: this.searchForm.getFieldValue('branch_id'),
        supplier_id: this.searchForm.getFieldValue('supplier_id'),
        // inner_type: this.searchForm.getFieldValue('inner_type'),
      }
      this.$refs.table.refresh()
    },
    handleList() {
      this.choose['branch_id'] = this.searchForm.getFieldValue('branch_id'),
        this.choose['supplier_id'] = this.searchForm.getFieldValue('supplier_id')
      //  this.choose['inner_type']= this.searchForm.getFieldValue('inner_type')
      if (this.choose.branch_id && this.choose.supplier_id) {
        this.visible = true
        getTotal(this.choose).then(res => {
          this.total = res.msg
        })
      } else {
        this.visible = false
        this.$message.error('未选择供应商或门店');
        this.choose = {}
      }
    },
    handleOk() {
      this.choose['branch_id'] = this.searchForm.getFieldValue('branch_id'),
        this.choose['supplier_id'] = this.searchForm.getFieldValue('supplier_id')
      if (this.choose) {
        sureCart(this.choose).then(res => {
          this.$message.success('上架成功')
          this.loading = false
          this.choose = {}
          this.visible = false
          this.$refs.table.refresh()
        })
      } else {
        this.visible = false
        this.$message.error('未选择供应商或门店');
        this.choose = {}
      }
    },
    handleCancel() {
      this.visible = false
      this.choose = {}
    },
    handleExport() {
      const params = {
        supplier_id: this.searchForm.getFieldValue('supplier_id'),
        branch_id: this.searchForm.getFieldValue('branch_id'),
        token: this.$ls.get(ACCESS_TOKEN)
      }
      window.open("/api/admin/temporaries/excel" + encodeJsonToQuery(params))
    },
  },

}
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}

.pic>img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
